import { Dialog } from '@headlessui/react';
import { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import CloseIcon from 'assets/icons/base/cancel-icon.svg';
import { useTranslate } from 'hooks';
import { getCardTypeIcon } from 'utils/validate-card';
import { Button, Input } from 'views/components/base/ui';

const CVVModal = ({
  googlePaymentData,
  isOpen,
  close,
  payment,
}: {
  googlePaymentData: google.payments.api.PaymentData;
  close: () => void;
  payment: (values: any) => void;
  isOpen: boolean;
}) => {
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useFormContext();
  const [cardTypeElem, setCardTypeElem] = useState<JSX.Element | null>();
  const { t } = useTranslate();

  useEffect(() => {
    if (googlePaymentData?.paymentMethodData.info) {
      const cardType = getCardTypeIcon(googlePaymentData.paymentMethodData.info.cardNetwork);

      setCardTypeElem(cardType);
    }
  }, [googlePaymentData]);

  const onSubmit = (data: any) => {
    payment(data);
  };

  return (
    <Dialog open={isOpen} onClose={close} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-sm w-full p-6 rounded-medium rounded bg-white">
          <header className="font-bold text-base mb-6 leading-6 flex justify-between items-center">
            <h3>Введите CVV</h3>
            <button
              type="button"
              className="w-[30px] h-[30px] flex justify-center items-center rounded-[8px] hover:bg-black/5"
              onClick={close}
            >
              <img src={CloseIcon} alt="close" width={24} height={24} />
            </button>
          </header>
          <form className="modal-mainContents">
            {googlePaymentData && (
              <div className="font-semibold mb-6 flex justify-between items-center">
                <div>{googlePaymentData?.paymentMethodData.description}</div>
                <div className="card__img">{cardTypeElem}</div>
              </div>
            )}
            <Controller
              name="cvv"
              control={control}
              rules={{
                required: true,
                pattern: {
                  value: /^\d{3,4}$/,
                  message: t('wrong_cvv_code'),
                },
              }}
              render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
                <Input
                  name="cvv"
                  label={t('cvv_code')}
                  mask=""
                  placeholder="xxx"
                  format="###"
                  value={value}
                  onChange={onChange}
                  ref={ref}
                  type="password"
                  error={error?.message}
                />
              )}
            />
            <div className="mt-6">
              <Button onClick={handleSubmit(onSubmit)} disabled={!isValid}>
                Продолжить
              </Button>
            </div>
          </form>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export { CVVModal };
